import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { ImageAndTextRowData } from '@data/proviotics';
import LinkImage from '@images/proviotics/link_img.svg';
import handleTextReplacement from '@utils/handleTextReplacement';
import LinkTranslated from './LinkTranslated';

interface Props {
  data: ImageAndTextRowData;
}

const ImageAndTextRow: React.FC<Props> = ({ data }) => {
  const image = getImage(data.image);
  const imageAlt = data.image.alt ?? '';
  const text = handleTextReplacement(data.text.text);

  return (
    <Container>
      <ImgWrap>{image && <GatsbyImage image={image} alt={imageAlt} />}</ImgWrap>
      {data?.link?.text ? (
        <LinkTranslated to={data.link.text} targetBlank>
          <TextWrap>
            <span>{text}</span>
            <LinkImage />
          </TextWrap>
        </LinkTranslated>
      ) : (
        <TextWrap>{text}</TextWrap>
      )}
    </Container>
  );
};

export default ImageAndTextRow;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  border-bottom: 1px solid ${Colors.ecru};

  a {
    align-self: center;
    @media (max-width: 1024px) {
      margin-inline: 30px;
    }
  }

  &:first-child {
    border-top: 1px solid ${Colors.ecru};

    @media (max-width: 1024px) {
      border-top-width: 0;
    }
  }

  @media (min-width: 1024px) {
    height: 127px;
  }

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-width: 0;
  }
`;

const ImgWrap = styled.div`
  max-width: 78px;
  width: 100%;
  display: flex;
  align-self: center;
  justify-content: center;

  @media (max-width: 1024px) {
    margin-right: 0;
    width: 65px;
    margin-bottom: 20px;
  }
`;

const TextWrap = styled.div`
  color: ${Colors.navyBlue};
  font-family: BrownStd;
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
  text-align: left;
  position: relative;
  width: 305px;
  margin-left: 30px;
  align-self: center;

  svg {
    margin-left: 4px;
  }

  @media (max-width: 1024px) {
    margin-left: 0;
    width: 100%;

    font-size: 16px;
    line-height: 24px;
    text-align: center;
    padding: 0 30px;
  }
`;
